import { render, staticRenderFns } from "./InsertCode.vue?vue&type=template&id=1c0a0a1a&"
import script from "./InsertCode.vue?vue&type=script&lang=js&"
export * from "./InsertCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports